import axios from "axios";
import { APIAddress } from "constants/config";
import updatePoster from "./updatePoster";

export default function unlinkPoster(posterId) {

  if (!posterId) {
    throw new Error('Missing posterId');
  }

  return updatePoster(posterId, {
    state: "closed",
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/poster/unlinkPoster.js